class jfCustomIssue {
	constructor($timeout, EventXDao, BinMgrDao, WebhooksDao, JFrogNotifications, XRayUtils, JFrogEventBus) {
		this.eventXDao = EventXDao;
		this.jFrogNotifications = JFrogNotifications;
		this.binMgrDao = BinMgrDao;
		this.webhooksDao = WebhooksDao;
		this.$timeout = $timeout;
		this.xrayUtils = XRayUtils;
		this.jfrogEventBus = JFrogEventBus;
		this.EVENTS = JFrogEventBus.getEventsDefinition();
		this.versionsSelect = [];
		this.severityOptions = [
            'Information',
            'Low',
            'Medium',
            'High'
		];
		this.eventTypeOptions = [
			'Security',
			'Versions',
			'Performance',
			'Other'
		];

    }

    $onInit() {

        if (this.issueId) {
            this._getIssue();
            this.editMode = true;

        }
        else {
            if (this.versionFilterOpt) {
                this.versionsSelect = [this.versionFilterOpt[0]];
                this.$timeout(() => {
                    this.tmpCurrVerFilterObj = this.versionFilterOpt[0];
                    this.versionsFilterTypes.splice(0, 1);
                }, 500);

            }
            this.issue = {
                component_id: this.componentId,
                severity: this.severityOptions[1],
                properties: []
            };

        }
        this.versionsFilterTypes = _.cloneDeep(this.versionFilterOpt);

    }
	_getIssue() {
		this.eventXDao.get({}, {sourceID: this.issueId}).$promise.then((issue) => {
			let compId = this.componentId;
            let ver = '';

			if (issue.components[0].vulnerable_versions) {
				this.versionsSelect = this.buildVulVersions(issue.components[0].vulnerable_versions);
				if (issue.components[0].vulnerable_versions[0] != '') {
					ver = ':' + issue.components[0].vulnerable_versions[0];
				}
			}
			this.issue = issue;
			this.issue.title = this.issue.summary;
			this.issue.component_id = compId;
			let propsArray = [];
			for (let key in this.issue.properties) {
				propsArray.push({key: key, value: this.issue.properties[key]});
			}
			this.issue.properties = propsArray;

        });
	}


	addProperty() {
		this.issue.properties.push({key: '', value: ''});
	}

	removeProperty(index) {
		this.issue.properties.splice(index, 1);
	}

	save() {
		let promise;
        if (this.issue.type.toLowerCase() === 'other') {
            this.issue.type = this.issue.other_type;
            delete this.issue.other_type;
        }
		if (!this.editMode) {
			promise = this.eventXDao.manualImpactAnalysis(this.getImpactRequestPayload(this.issue)).$promise;
		}
		else {
			promise = this.eventXDao.updateIssue(_.extend(this.getImpactRequestPayload(this.issue).vulnerability,
				{vulnerabilityID: this.issueId})).$promise;
		}
		promise.then(() => {
			this.jFrogNotifications.create({info: 'Manual Impact Analysis Started'});
			this.jfrogEventBus.dispatch(this.EVENTS.GENERAL_DETAILS_RECIEVED);
			this.$timeout(() => {
				this.jfrogEventBus.dispatch(this.EVENTS.COMPONENT_VERSION_SELECTED);
            }, 500);


			this.jfrogEventBus.dispatch(this.EVENTS.CUSTOM_ISSUE_INJECTED);

			this.$close();
		})
		       .catch(() => {
			       this.jFrogNotifications.create({error: 'Manual Impact Analysis Failed To Start'});
			       this.$close();
		       });
	}

	getImpactRequestPayload(issue) {
		const properties = issue.properties.reduce((result, nextValue) => {
			result[nextValue.key] = nextValue.value;
			return result;
		}, {});

		const payload = {};
		let vulVersions = this.setVulenrableVersion(this.versionsSelect);
        if (this.pkgType == 'pypi') {
            this.pkgType = 'pip';
		}
		payload.vulnerability = {
            'type': issue.type || 'Other',
            'provider': 'Custom',
            'package_type': this.pkgType,
            'severity': issue.severity,
            'properties': properties,
            'components': [
				{
                    'id': this.pkgId.split('://')[1],
                    'vulnerable_versions': vulVersions
				}
			],
            'summary': issue.title,
            'description': issue.description
		};
		if (!this.editMode) {
			payload.vulnerability.id = 'CustomIssue_' + this.xrayUtils.randomString(16);
            payload.vulnerability.sources = [{'source_id': 'CustomIssue_' + this.xrayUtils.randomString(16)}];
		}
		if (issue.emails) {
			if (!payload.watch.notifications) {
				payload.watch.notifications = {};
			}
			payload.watch.notifications.emails = issue.emails;
		}
		if (issue.webhooks) {
			if (!payload.watch.notifications) {
				payload.watch.notifications = {};
			}
			payload.watch.notifications.webhooks = issue.webhooks;
		}

		return payload;
	}

	addVersionFilter() {
		if (this.selectedVersionOpt) {
            this.versionsSelect.push(_.cloneDeep(this.selectedVersionOpt));
		}

		if (this.selectedVersionOpt.type == 'current') {

            let index = _.findIndex(this.versionsFilterTypes, {'type': 'current'});
			this.versionsFilterTypes.splice(index, 1);
			this.tmpCurrVerFilterObj = _.cloneDeep(this.selectedVersionOpt);
		}


		delete this.selectedVersionOpt;
	}


	removeFilter(index, filter) {
		//delete this.versions[filter.type][index];
		this.versionsSelect.splice(index, 1);

		if (filter.type === 'current') {
			this.versionsFilterTypes.unshift(_.cloneDeep(this.tmpCurrVerFilterObj));
			delete this.tmpCurrVerFilterObj;
		}

	}

	setVulenrableVersion(versions) {
		let vulVersionsArr = [];
		_.each(versions, (val, key) => {
			let rangeSyntax;
			switch (val.type) {
				case 'current':
				case 'specific':
					rangeSyntax = `[${val.value}]`;
					vulVersionsArr.push(rangeSyntax);
					break;
				case 'range':
					rangeSyntax = `(${val.value.from},${val.value.to})`;
					vulVersionsArr.push(rangeSyntax);
					break;
				case 'greater':
					rangeSyntax = `(${val.value},)`;
					vulVersionsArr.push(rangeSyntax);
					break;
				case 'greater-equal':
					rangeSyntax = `[${val.value},)`;
					vulVersionsArr.push(rangeSyntax);
					break;
				case 'lower':
					rangeSyntax = `(,${val.value})`;
					vulVersionsArr.push(rangeSyntax);
					break;
				case 'lower-equal':
					rangeSyntax = `(,${val.value}]`;
					vulVersionsArr.push(rangeSyntax);
					break;
				case 'all':
					rangeSyntax = `(,)`;
					vulVersionsArr.push(rangeSyntax);
					break;
			}

		});
		return vulVersionsArr;
	}

	buildVulVersions(vulnerable_versions) {
		let tmpVersionSelect = [];
		_.forEach(vulnerable_versions, (val, key) => {

			let tmpObj = {};
			tmpObj.filterGroup = 'version';
			if (val.toLowerCase().indexOf('version') > -1) {

				if (val !== 'All Versions') {
					tmpObj.type = 'range';
					tmpObj.uiType = 'range';
					tmpObj.displayName = 'Version Lower or Equal Than';
					tmpObj.value = {};
					tmpObj.value.from = val.split(' ')[0];
					tmpObj.value.to = val.split(' ')[4];

				} else {
					tmpObj.type = 'all';
					tmpObj.uiType = 'string';
					tmpObj.displayName = 'All Versions';
                    tmpObj.value = 'All Versions';
					tmpObj.isReadOnly = true;

				}

			} else if (val.indexOf(' ') < 0) {

				tmpObj.type = 'specific';
				tmpObj.uiType = 'string';
				tmpObj.displayName = 'Specific Version';
				tmpObj.value = {};
				tmpObj.value = val;

			}
			else {
				switch (val.charAt(0)) {
                    case '≤': {
						tmpObj.type = 'lower-equal';
						tmpObj.uiType = 'string';
						tmpObj.displayName = 'Version Lower or Equal Than';
						tmpObj.value = val.split(' ')[1];
						break;
					}
                    case '<': {
						tmpObj.type = 'lower';
						tmpObj.uiType = 'string';
						tmpObj.displayName = 'Version Lower Than';
						tmpObj.value = val.split(' ')[1];
						break;
					}
                    case '>': {
						tmpObj.type = 'greater';
						tmpObj.uiType = 'string';
                        tmpObj.displayName = 'Version Lower Than';
						tmpObj.value = val.split(' ')[1];
						break;
					}
                    case '≥': {
						tmpObj.type = 'greater-equal';
						tmpObj.uiType = 'string';
                        tmpObj.displayName = 'Version Lower Than';
						tmpObj.value = val.split(' ')[1];
						break;
					}
				}
			}// if it's not range


            tmpVersionSelect.push(tmpObj);
		});

        return tmpVersionSelect;

	}

}

export function jfCustomIssue() {

	return {
		restrict: 'E',
		scope: {
			internalVersions: '=?',
			componentId: '@?',
			versionFilterOpt: '=?',
			pkgType: '=?',
			pkgId: '=?',
			issueId: '@?',
			$dismiss: '&',
			$close: '&'
		},
		controller: jfCustomIssue,
		controllerAs: 'jfCustomIssue',
		template: require('./jf_custom_issue.html'),
		bindToController: true
	};
}



// WEBPACK FOOTER //
// ./modules/xray/directives/jf_custom_issue/jf_custom_issue.js